import { tenantService } from '@/services/tenant.service';

export const state = {
    tenants: JSON.parse(localStorage.getItem('tenants')),
    currency: JSON.parse(localStorage.getItem('currency')),
    currencyTenantId: null,
    banks: JSON.parse(localStorage.getItem('banks')),
    bankTenantId: null,
};

export const getters = {
    getTenants: state => {
        return state.tenants;
    },
    getCurrency: state => {
        return state.currency;
    },
};

export const actions = {
    async fetchTenants({ commit }) {
        const res = await tenantService.getAllTenantDescendantsByUserId();
        commit('setTenants', res.data);
    },
    async fetchTenantCurrency({ state, commit }, tenantId) {
        if (state.currency?.symbol && state.currencyTenantId === tenantId) {
            return state.currency;
        } 
        const res = await tenantService.getTenantCurrency(tenantId);
        commit('setCurrency', { currency: res.data.tenant, tenantId });
        return res.data.tenant;
    },
    async fetchTenantBanks({ state, commit }, tenantId) {
        if (state.banks && state.banks.length && state.banks.length>1 && state.bankTenantId === tenantId) {
            return state.banks;
        } 
        const res = await tenantService.getTenantBanks(tenantId);
        commit('setBanks', { banks: res.data.banks, tenantId });
        return res.data.tenant;
    },
};

export const mutations = {
    setTenants: (state, tenants) => {
        state.tenants = tenants;
        localStorage.setItem('tenants', JSON.stringify(tenants));
    },
    setCurrency: (state, { currency, tenantId }) => {
        state.currency = currency;
        state.currencyTenantId = tenantId;
        localStorage.setItem('currency', JSON.stringify(currency));
    },
    setBanks: (state, { banks, tenantId }) => {
        state.banks = banks;
        state.bankTenantId = tenantId;
        localStorage.setItem('banks', JSON.stringify(banks));
    },
};
